<template>
  <!-- 全部客户：全量但排除公海；不提供「新增」 -->
  <CustomerList :pool="false" :show-create="false" :show-tabs="false" />
</template>

<script lang="ts" setup>
import CustomerList from '../components/CustomerList.vue'

defineOptions({ name: 'CrmCustomerAll' })
</script>
